// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c9f9786d","498":"986a5741","703":"aff2cca3","787":"448f182c"}[chunkId] + ".chunk.js";
};